module.exports = __webpack_public_path__ + "img/company.21b1a6ee.png";